import React from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "../components/admin/navigation-bar/Navbar";
import Dashboard from "../components/admin/dashboard/Dashboard";
import ViewProfile from "../components/admin/admin-view-profile/ViewProfile";
import ClientList from "../components/admin/client-list/ClientList";
import AddEmployee from "../components/admin/add-employee/AddEmployee";
import ActiveEmployee from "../components/admin/employee/ActiveEmployee";
import InactiveEmployee from "../components/admin/employee/InactiveEmployee";
import ClientCandidates from "../components/admin/clients-candidates/ClientCandidates";
import AdminServiceHandle from "../components/service-down/AdminServiceHandle";
import AssignedCandidates from "../components/admin/employee-candidates/AssignedCandidates";
import CandidateReport from "../components/admin/reports/CandidateReport";
import CandidateDetails from "../components/admin/candidate-details/CandidateDetails";
import CandidateStatusList from "../components/admin/candidates/CandidateStatusList";
import ChangePassword from "../components/change-password/ChangePassword";
import PendingClients from "../components/admin/client-list/PendingClients";
import AllBgvCasesPage from "../components/admin/AllBgvCases/AllBgvCasesPage";
import PricingPage from "../components/Payment/Pricing/PricingPage";
import AdminTransactionHistory from "../components/Payment/Admin/AdminTransactionHistory";
import PostClientPricing from "../components/Payment/Pricing/PostClientPricing";
import ClientPaymentDetails from "../components/admin/client-payment-details/ClientPaymentDetails";
import EmployeePerformanceReport from "../components/admin/EmployeePerformanceReport";
import ClientUsageReport from "../components/admin/reports/ClientUsageReport";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navbar />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="view-profile" element={<ViewProfile />} />
        <Route path="clients/pending" element={<PendingClients />} />
        {/* <Route path="clients" element={<ClientList searchTerm="" />} /> */}
        <Route path="clients" element={<ClientList status="APPROVED" />} />
        <Route
          path="clients/pending"
          element={<ClientList status="PENDING" />}
        />
        <Route
          path="clients/rejected"
          element={<ClientList status="REJECTED" />}
        />
        <Route path="bgv-cases" element={<AllBgvCasesPage />} />
        <Route path="add-employee" element={<AddEmployee />} />
        <Route
          path="active-employee"
          element={<ActiveEmployee searchTerm="" />}
        />
        <Route
          path="inactive-employee"
          element={<InactiveEmployee searchTerm="" />}
        />
        <Route
          path="client/:clientId/candidates"
          element={<ClientCandidates />}
        />
        <Route
          path="employee/:employeeId/candidates"
          element={<AssignedCandidates />}
        />
        <Route
          path="employee-performance/:employeeId"
          element={<EmployeePerformanceReport />}
        />
        <Route path="reports/:candidateId" element={<CandidateReport />} />
        <Route
          path="candidate-details/:candidateId"
          element={<CandidateDetails />}
        />
        <Route path="candidates/:status" element={<CandidateStatusList />} />
        <Route path="change-password" element={<ChangePassword />} />{" "}
        {/* /admin/change-password */}
        <Route path="service-down" element={<AdminServiceHandle />} />
        {/* <Route path="pricing/:clientId" element={<PricingPage />} /> */}
        {/* <Route path="client-pricing/:clientId" element={<PostClientPricing />} /> */}
        {/* <Route path="transaction-history/:clientId" element={<AdminTransactionHistory />} /> */}
        {/* <Route path="client-payment-details" element={<ClientPaymentDetails />} /> */}
        <Route path="reports/client-usage/:clientId?" element={<ClientUsageReport />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
